<template id="dataCollection">
  <div class="dataCollection">
    <div class="top">
      <div class="Title">家庭成员信息</div>
      <div class="information">
        <div class="oneself">
          <div class="text">本人</div>
            <div class="checkDataRow">{{obj.oneself.name}}目前{{obj.oneself.age}}岁，
              <span v-if="obj.oneself.age<obj.oneself.retirementAge"   class="location">
                  预计于<el-select v-model="obj.oneself.retirementAge" style="width:60px;" >
                  <el-option v-for="item in spouse.retireAgeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                  </el-option>
                </el-select>
              </span>
              <span v-else class="checkDataRow">
                  已于<span class="checkDataCol location">
                  <el-select v-model="obj.oneself.retirementAge"  style="width:60px;">
                  <el-option v-for="item in spouse.retireAgeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                  </el-option>
                </el-select>
                </span>
              </span>岁退休。本次规划截至年龄至
              <span class="checkDataCol location">
              <el-select  v-model="obj.oneself.endYear" @change="selectChecked()" style="width:70px;" >
                <el-option v-for="item in spouse.byAgeList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                </el-option>
              </el-select>
              <p class="verificationText" style="position: absolute;padding: 2%; top: 100%; width: 150px;"  v-if="pensionInputText.self.retirementAge.statusEndYear" >{{pensionInputText.self.retirementAge.textEndYear}}</p>
            </span>岁。
            </div>

          <div style="display: flex;flex-direction:row;">当前每月开支为
            <span style="display: flex;flex-direction:column;" >
            <el-input type="text"
                      v-model="obj.oneself.monthExpend"
                      @blur="pensionReserveBlurFn(obj.oneself.monthExpend, $event, 5)"
                      @focus="educationReserveFocusFn($event)"
                      @input.native="obj.oneself.monthExpend=
              obj.oneself.monthExpend.replace
              (obj.oneself.monthExpend,RestrictedMoney
              (obj.oneself.monthExpend))"
                      style="width:158px;" class="location"></el-input>
                  <p class="verificationText" style="padding: 2%;"  v-if="pensionInputText.self.monthExpend.monthExpendStatus" >{{pensionInputText.self.monthExpend.monthExpendText}}</p>
              </span>元。

          </div>

          <div class="single-election">养老金来源：<div>
              <el-radio v-model="obj.oneself.pensionSource"
                        label="1">家庭养老金</el-radio>
              <el-radio v-model="obj.oneself.pensionSource"
                        label="2">城镇企业职工社保+家庭养老金</el-radio>
              <el-radio v-model="obj.oneself.pensionSource"
                        label="3">个体工商户和灵活就业人员社保+家庭养老金</el-radio>
            </div>
          </div>
          <div  v-show="obj.oneself.age < obj.oneself.retirementAge">
              <div v-show="obj.oneself.pensionSource==='3'||obj.oneself.pensionSource==='2'" class="checkDataRow">
                社保缴费开始于<el-select style="width:150px;" class="location"
                          v-model="obj.oneself.socialSecurityYear">
                  <el-option v-for="item in spouse.BeginningYearList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                  </el-option>
                </el-select>，截至上年末养老金账户结余
                <span class="checkDataCol">
                <el-input style="width:158px;" class="location"
                          v-model="obj.oneself.pensionYearEndBalance"
                          @focus="educationReserveFocusFn($event)"
                          @blur="pensionReserveBlurFn(obj.oneself.pensionYearEndBalance, $event, 6)"
                           @input.native="obj.oneself.pensionYearEndBalance=
              obj.oneself.pensionYearEndBalance.replace
              (obj.oneself.pensionYearEndBalance,RestrictedMoney
              (obj.oneself.pensionYearEndBalance))"
                          ></el-input>
                <p class="verificationText" style="padding: 2% 0"  v-show="pensionInputText.self.pensionYearEndBalance.pensionYearEndBalanceStatus && (this.obj.oneself.pensionSource==2 ||this.obj.oneself.pensionSource==3 )" >{{pensionInputText.self.pensionYearEndBalance.pensionYearEndBalanceText}}</p>
                </span>元。
                </div>
              <div v-show="obj.oneself.pensionSource==='2'" style="margin-top:2%;">
                  <span v-show="obj.oneself.age < obj.oneself.retirementAge " class="checkDataRow">
                      每月工资
                      <span class="checkDataCol">
                          <el-input v-model="obj.oneself.monthSalary" class="location"
                          @blur="pensionReserveBlurFn(obj.oneself.monthSalary, $event, 7)"
                          @focus="educationReserveFocusFn($event)"
                          @input.native="obj.oneself.monthSalary=
                          obj.oneself.monthSalary.replace
                          (obj.oneself.monthSalary,RestrictedMoney
                          (obj.oneself.monthSalary))"
                          style="width:158px;" ></el-input>
                          <p class="verificationText" style="padding: 2%;"  v-show="pensionInputText.self.monthSalary.monthSalaryStatus && this.obj.oneself.pensionSource==2 " >{{pensionInputText.self.monthSalary.monthSalaryText}}</p>
                      </span>
                          元，
                预计工资每年涨幅为<span class="checkDataCol">  <el-input v-model="obj.oneself.wageIncrease" class="location"
                          @blur="pensionReserveBlurFn(obj.oneself.wageIncrease, $event, 8)"
                          @input.native="obj.oneself.wageIncrease=
                          obj.oneself.wageIncrease.replace
                          (obj.oneself.wageIncrease,RestrictedMoney3
                          (obj.oneself.wageIncrease))"
                          style="width:150px;"></el-input>
                           <p class="verificationText" style="padding: 2%;"  v-show="pensionInputText.self.wageIncrease.wageIncreaseStatus && this.obj.oneself.pensionSource==2 " >{{pensionInputText.self.wageIncrease.wageIncreaseText}}</p>
                           </span>%
                  </span>

              </div>
              <div v-show="obj.oneself.pensionSource==='3'" style="margin-top:2%;" >
                  <span v-show="obj.oneself.age < obj.oneself.retirementAge " class="checkDataRow">
                      养老金缴费档次为
                      <span class="checkDataCol" style="position: relative;"> <el-input style="width:158px;" class="location"
                          v-model="obj.oneself.pensionPaymentScale"
                           placeholder="请输入60-300间的整数"
                           @blur="pensionReserveBlurFn(obj.oneself.pensionPaymentScale, $event, 9)"
                           @input.native="obj.oneself.pensionPaymentScale=
              obj.oneself.pensionPaymentScale.replace
              (obj.oneself.pensionPaymentScale,RestrictedMoney3
              (obj.oneself.pensionPaymentScale))"
                          ></el-input>
                          <p class="verificationText"    v-show="pensionInputText.self.pensionPaymentScale.pensionPaymentScaleStatus && this.obj.oneself.pensionSource==3 "  style=" position: absolute; top: 35px;width: 195px;">{{pensionInputText.self.pensionPaymentScale.pensionPaymentScaleText}}</p>
                      </span>%
                  </span>
              </div>
        </div>
          <span v-show="obj.oneself.pensionSource==='3'||obj.oneself.pensionSource==='2'">
              <span v-show="obj.oneself.age >= obj.oneself.retirementAge" class="checkDataRow">
                  每月领取社保养老金<span class="checkDataCol">
                    <el-input style="width:158px;" class="location"
                          v-model="obj.oneself.socialSecurityPension"
                          @focus="educationReserveFocusFn($event)"
                          @blur="pensionReserveBlurFn(obj.oneself.socialSecurityPension, $event, 10)"
                          @input.native="obj.oneself.socialSecurityPension=
                          obj.oneself.socialSecurityPension.replace
                          (obj.oneself.socialSecurityPension,RestrictedMoney
                          (obj.oneself.socialSecurityPension))"
                        ></el-input>
                        <p class="verificationText" style="padding: 2%;"  v-show="pensionInputText.self.socialSecurityPension.socialSecurityPensionStatus && this.obj.oneself.pensionSource!=1" >{{pensionInputText.self.socialSecurityPension.socialSecurityPensionText}}</p>
                        </span>元
              </span>
          </span>
        </div>
        <div class="spouse"
             v-if="obj.spouseTwo.name">
          <div class="text">配偶</div>
          <div class="checkDataRow">{{obj.spouseTwo.name}}目前{{obj.spouseTwo.age}}岁，
          <span   class="location" v-if="obj.spouseTwo.age < obj.spouseTwo.retirementAge" >
            预计于<el-select v-model="obj.spouseTwo.retirementAge"
            style="width:60px;">
              <el-option v-for="item in spouse.retireAgeList"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </span>
          <span  v-else class="checkDataRow">
                  已于
                  <span class="checkDataCol location">
                  <el-select v-model="obj.spouseTwo.retirementAge"   style="width:60px;">
                  <el-option v-for="item in spouse.retireAgeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                  </el-option>
                </el-select>
                </span>
          </span>
             岁退休。
          </div>
          <div class="checkDataRow">当前每月开支为 <span class="checkDataCol">
            <el-input type="text"  class="location"
                      v-model="obj.spouseTwo.monthExpend" @blur="pensionReserveBlurFn(obj.spouseTwo.monthExpend, $event, 11)"
                      @focus="educationReserveFocusFn($event)"
                      @input.native="obj.spouseTwo.monthExpend=
                      obj.spouseTwo.monthExpend.replace
                      (obj.spouseTwo.monthExpend,RestrictedMoney
                      (obj.spouseTwo.monthExpend))"
                      style="width:158px;"></el-input>
                      <span class="verificationText" style="padding: 2%;"  v-if="pensionInputText.spouse.monthExpend.monthExpendStatus" >{{pensionInputText.spouse.monthExpend.monthExpendText}}</span></span>元。</div>

          <div class="single-election">养老金来源：<div>
              <el-radio v-model="obj.spouseTwo.pensionSource"
                        label="1">家庭养老金</el-radio>
              <el-radio v-model="obj.spouseTwo.pensionSource"
                        label="2">城镇企业职工社保+家庭养老金</el-radio>
              <el-radio v-model="obj.spouseTwo.pensionSource"
                        label="3">个体工商户和灵活就业人员社保+家庭养老金</el-radio>
            </div>
          </div>
          <div  v-show="obj.spouseTwo.age < obj.spouseTwo.retirementAge">
              <div  v-show="obj.spouseTwo.pensionSource==='2'||obj.spouseTwo.pensionSource==='3'" class="checkDataRow">社保缴费开始于
                <el-select style="width:150px;" v-model="obj.spouseTwo.socialSecurityYear" class="location">
                  <el-option v-for="item in spouse.BeginningYearList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                  </el-option>
                </el-select>，截至上年末养老金账户结余
                <span class="checkDataCol" >
                <el-input style="width:158px;"
                          v-model="obj.spouseTwo.pensionYearEndBalance"
                          @blur="pensionReserveBlurFn(obj.spouseTwo.pensionYearEndBalance, $event, 12)"
                          @focus="educationReserveFocusFn($event)"
                          @input.native="obj.spouseTwo.pensionYearEndBalance=
              obj.spouseTwo.pensionYearEndBalance.replace
              (obj.spouseTwo.pensionYearEndBalance,RestrictedMoney
              (obj.spouseTwo.pensionYearEndBalance))"
                          class="location"
                          ></el-input>
                <p class="verificationText" style="padding: 2% 0;"  v-show="pensionInputText.spouse.pensionYearEndBalance.pensionYearEndBalanceStatus && (this.obj.spouseTwo.pensionSource==2 ||this.obj.spouseTwo.pensionSource==3 )" >{{pensionInputText.spouse.pensionYearEndBalance.pensionYearEndBalanceText}}</p>
            </span>元。
             </div>
              <div v-show="obj.spouseTwo.pensionSource==='2'" style="margin-top:2%;">
                  <span v-show="obj.spouseTwo.age < obj.spouseTwo.retirementAge "  class="checkDataRow">
                    每月工资 <span class="checkDataCol"> <el-input              v-model="obj.spouseTwo.monthSalary"
                      @blur="pensionReserveBlurFn(obj.spouseTwo.monthSalary, $event, 13)"
                      @focus="educationReserveFocusFn($event)"
                      @input.native="obj.spouseTwo.monthSalary=
                      obj.spouseTwo.monthSalary.replace
                      (obj.spouseTwo.monthSalary,RestrictedMoney
                      (obj.spouseTwo.monthSalary))"  class="location"
                          style="width:158px;"></el-input> <span class="verificationText" style="padding: 2%;"  v-show="pensionInputText.spouse.monthSalary.monthSalaryStatus && this.obj.spouseTwo.pensionSource==2" >{{pensionInputText.spouse.monthSalary.monthSalaryText}}</span> </span>   元，
                预计工资每年涨幅为<span class="checkDataCol">
                <el-input v-model="obj.spouseTwo.wageIncrease" class="location"
                  @blur="pensionReserveBlurFn(obj.spouseTwo.wageIncrease, $event, 14)"
                  @input.native="obj.spouseTwo.wageIncrease=
                  obj.spouseTwo.wageIncrease.replace
                  (obj.spouseTwo.wageIncrease,RestrictedMoney3
                  (obj.spouseTwo.wageIncrease))"
                  style="width:158px;" >
                </el-input> <span class="verificationText" style="padding:2%;"  v-show="pensionInputText.spouse.wageIncrease.wageIncreaseStatus  && this.obj.spouseTwo.pensionSource==2" >{{pensionInputText.spouse.wageIncrease.wageIncreaseText}}</span> </span>   %
                  </span>
              </div>
              <div v-show="obj.spouseTwo.pensionSource==='3'" style="margin-top:2%;">
                  <span v-show="obj.spouseTwo.age < obj.spouseTwo.retirementAge" class="checkDataRow">
                    养老金缴费档次为 <span class="checkDataCol" style="position: relative;">
                      <el-input style="width:158px;"
                          v-model="obj.spouseTwo.pensionPaymentScale"
                          placeholder="请输入60-300间的整数"
                          @blur="pensionReserveBlurFn(obj.spouseTwo.pensionPaymentScale, $event, 15)"  class="location"
                           @input.native="obj.spouseTwo.pensionPaymentScale=
              obj.spouseTwo.pensionPaymentScale.replace
              (obj.spouseTwo.pensionPaymentScale,RestrictedMoney3
              (obj.spouseTwo.pensionPaymentScale))"
                          ></el-input><p class="verificationText" style="position: absolute; top: 100%;width: 195px;"  v-show="pensionInputText.spouse.pensionPaymentScale.pensionPaymentScaleStatus  && this.obj.spouseTwo.pensionSource==3" >{{pensionInputText.spouse.pensionPaymentScale.pensionPaymentScaleText}}</p></span>%
                  </span>
              </div>
          </div>
           <span v-show="obj.spouseTwo.pensionSource==='3'||obj.spouseTwo.pensionSource==='2'" >
              <span v-show="obj.spouseTwo.age >= obj.spouseTwo.retirementAge" class="checkDataRow">
                  每月领取社保养老金<span class="checkDataCol">
                   <el-input style="width:158px;"
                      v-model="obj.spouseTwo.socialSecurityPension"
                      @blur="pensionReserveBlurFn(obj.spouseTwo.socialSecurityPension, $event, 16)"  class="location"
                      @focus="educationReserveFocusFn($event)"
                      @input.native="obj.spouseTwo.socialSecurityPension=
                      obj.spouseTwo.socialSecurityPension.replace
                      (obj.spouseTwo.socialSecurityPension,RestrictedMoney
                      (obj.spouseTwo.socialSecurityPension))"
                  ></el-input>
                  <span class="verificationText" style="padding: 2%;"  v-show="pensionInputText.spouse.socialSecurityPension.socialSecurityPensionStatus && this.obj.spouseTwo.pensionSource!=1" >{{pensionInputText.spouse.socialSecurityPension.socialSecurityPensionText}}</span> </span>元
              </span>
          </span>
        </div>
        <div class="spouse" v-else>
          <div class="text">配偶</div>
          <div class="img">
            <img src="@/assets/images/wpsp/pension-planning/编组 7.png"
                 alt="">
            <span>客户尚未维护配偶信息。</span>
          </div>
        </div>
      </div>
    </div>
    <div class="dataCollection-bottom">
      <div class="Title">家庭养老金</div>
      <div class="information">
        <div class="dataCollection-bottom-left">
          <div  class="checkDataRow">客户当前已为养老准备了家庭养老金<span class="checkDataCol location"> <el-input style="width:158px;" v-model="obj.threeReserve.currentMoney"
             @input.native="obj.threeReserve.currentMoney=
              obj.threeReserve.currentMoney.replace
              (obj.threeReserve.currentMoney,RestrictedMoney
              (obj.threeReserve.currentMoney))"
            @blur="pensionReserveBlurFn(obj.threeReserve.currentMoney, $event, 1)"
            @focus="educationReserveFocusFn($event)"
            ></el-input> <p class="verificationText" style="padding: 2%;"  v-if="pensionReserveText.currentMoney.currentMoneyStatus">{{pensionReserveText.currentMoney.currentMoneyText}}</p></span>   元。 </div>
          <div class="checkDataRow">计划未来每月储蓄<span class="checkDataCol location"> <el-input style="width:158px;" v-model="obj.threeReserve.monthMoney"
              @input.native="obj.threeReserve.monthMoney=
              obj.threeReserve.monthMoney.replace
              (obj.threeReserve.monthMoney,RestrictedMoney
              (obj.threeReserve.monthMoney))"
              @focus="educationReserveFocusFn($event)"
              @blur="pensionReserveBlurFn(obj.threeReserve.monthMoney, $event, 2)" ></el-input>
           <p class="verificationText" style="padding: 2%;"  v-if="pensionReserveText.monthMoney.monthMoneyStatus" >{{pensionReserveText.monthMoney.monthMoneyText}}</p>
           </span>
           元。
           </div>
          <div class="checkDataRow">期望每年能产生<span class="checkDataCol location"><el-input style="width:158px;" v-model="obj.threeReserve.expectedRevenue"
           @input.native="obj.threeReserve.expectedRevenue=
              obj.threeReserve.expectedRevenue.replace
              (obj.threeReserve.expectedRevenue,RestrictedMoney3
              (obj.threeReserve.expectedRevenue))"
          @blur="pensionReserveBlurFn(obj.threeReserve.expectedRevenue, $event, 3)"></el-input> <p class="verificationText" style="padding: 2%;"  v-if="pensionReserveText.expectedRevenue.expectedRevenueStatus">{{pensionReserveText.expectedRevenue.expectedRevenueText}}</p> </span>%的收益率。</div>
        </div>
        <div class="dataCollection-bottom-right">
          <div>
            <div class="text" style="color:#303133;font-weight:500;">Tips：</div>
            <div class="content">
              <span class="circular"></span>
              <p>退休养老规划中涉及的社保养老金计算视同客户已累计缴费满15年，且男性退休年龄为60周岁，女性退休年龄为50周岁。</p>
            </div>
            <div class="content">
              <span class="circular"></span>
              <div>
                <p>城镇企业职工社保养老金计算公式：</p>
                <p>月基本养老金=月基础养老金+月个人账户养老金；</p>
                <p>月基础养老金=全省上年度在岗职工月平均工资(1+本人平均缴费指数)/2 * 缴费年限*1 % </p>
                <p>月个人账户养老金=个人账户全部储存额/计发月数；<el-button type="text"
                             style="padding:0px;"
                             @click="dialogVisible = true">查看计发月数</el-button>
                </p>
              </div>
            </div>
            <div class="content">
              <span class="circular"></span>
                <p>个体工商户和灵活就业人员：基础养老金与城镇企业职工相同，个人账户养老金可在本省平均工资60%－300%之间自愿选择缴费基数。</p>
           </div>
            <div class="content">
              <span class="circular"></span>
              <p>默认在岗职工月平均工资涨幅为5%，</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="计发月数查询"
               :visible.sync="dialogVisible"
               width="60%"
               :close-on-click-modal="false"
               >
      <el-table :data="tableData1"
                style="width: 100%" :header-cell-style="{ background: '#F5F7FA' }">
        <el-table-column label="退休年龄"  prop="paramExplain" align="center">
        </el-table-column>
        <el-table-column prop="paramValue"
                         label="计发月数"  align="center">
        </el-table-column>
      </el-table>
      <el-table :data="tableData2"
                style="width: 100%" :header-cell-style="{ background: '#F5F7FA' }">
        <el-table-column label="退休年龄"  prop="paramExplain" align="center">
        </el-table-column>
        <el-table-column prop="paramValue"
                         label="计发月数" align="center">
        </el-table-column>
      </el-table>

      <span slot="footer"
            class="dialog-footer">
      <div style="width: 41%;">
        <span style="font-weight:500;color:rgba(48,49,51,1);">Tips：</span>
        <span>计发月数为社保养老金发放期间的计划发放月数。</span>
      </div>
        <el-button type="primary"
                   @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="更新信息"
               :visible.sync="dialogVisible2"
               width="30%"
               >
               <!-- :before-close="handleClose" -->
      <span>本人或配偶信息有变化，若更新将会初始化页面数据，是否更新？</span>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="cancel()">取 消</el-button>
        <el-button type="primary"
                   @click="determine()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'dataCollection',
  data() {
    return {
      // 本人数据
      obj: {
        oneself: {
          presentAge: 30, // 当前年龄
          retireAge: 60, // 退休年龄
          retireAgeList: [], // 退休年龄下拉框值
          byAge: 100, // 截至年龄
          byAgeList: [], // 截至年龄下拉框值
          expenditure: 100, // 每月开支
          radio: '1',
          BeginningYear: '', // 缴费开始年份
          BeginningYearList: [], // 缴费开始年份下拉框值
          BalanceMoney: '', // 结余金额
          monthlyMoney: '', // 每月工资
          gainMoney: '5', // 工资涨幅
          payGrade: '', // 缴费档次
          socialSecurityYear: '',
          pensionYearEndBalance: '',
          monthSalary: '',
          wageIncrease: '',
          planStartYear: '',
          planEndYear: '',
          socialSecurityPension: '',
        },
        spouseTwo: {
          self: '0',
          name: '', // 名称
          age: '', // 配偶年龄
          monthExpend: '', // 月开支
          pensionSource: '', // 养老金来源
          retirementAge: '', // 退休年龄
          monthSalary: '', // 月工资
          wageIncrease: '', // 工资涨幅
          socialSecurityYear: '',
          pensionYearEndBalance: '',
          planStartYear: '',
          planEndYear: '',
          socialSecurityPension: '',
        },
        threeReserve: {
          currentMoney: 0, // 已存在家庭养老金
          monthMoney: 0, // 每月投入
          expectedRevenue: 0, // 期望收益
        },
      },
      // 配偶数据
      spouse: {
        retireAgeList: [], // 退休年龄下拉框值
        byAge: 100, // 截至年龄
        byAgeList: [], // 截至年龄下拉框值
        BeginningYearList: [], // 缴费开始年份下拉框值
      },
      dialogVisible: false, // 查看计发月数
      tableData1: [], // 计发月数表格数据
      tableData2: [], // 计发月数表格数据
      dialogVisible2: false, // 更新提示
      pensionPlanReserve: {
        currentMoney: 0, // 已存在家庭养老金
        monthMoney: 0, // 每月投入
        expectedRevenue: 0, // 期望收益
      },
      pensionReserveText: {// 养老金提示文本框
        currentMoney: {
          currentMoneyText: '',
          currentMoneyStatus: false,
        },
        monthMoney: {
          monthMoneyText: '',
          monthMoneyStatus: false,
        },
        expectedRevenue: {
          expectedRevenueText: '',
          expectedRevenueStatus: false,
        },
      },
      pensionInputText: {// 客户基本信息提示框
        self: {
          retirementAge: {
            statusRetirementAge: false,
            textRetirementAge: '',
          },
          endYear: {
            statusEndYear: false,
            textEndYear: '',
          },
          pensionYearEndBalance: {
            pensionYearEndBalanceStatus: false,
            pensionYearEndBalanceText: '',
          },
          monthSalary: {
            monthSalaryStatus: false,
            monthSalaryText: '',
          },
          wageIncrease: {
            wageIncreaseStatus: false,
            wageIncreaseText: '',
          },
          monthExpend: {
            monthExpendStatus: false,
            monthExpendText: '',
          },
          pensionPaymentScale: {// 养老缴费档次
            pensionPaymentScaleStatus: false,
            pensionPaymentScaleText: '',
          },
          // 每月领取社保养老金
          socialSecurityPension: {
            socialSecurityPensionStatus: false,
            socialSecurityPensionText: '',
          },
        },
        spouse: {
          retirementAge: {
            statusRetirementAge: false,
            textRetirementAge: '',
          },
          pensionYearEndBalance: {
            pensionYearEndBalanceStatus: false,
            pensionYearEndBalanceText: '',
          },
          monthSalary: {
            monthSalaryStatus: false,
            monthSalaryText: '',
          },
          wageIncrease: {
            wageIncreaseStatus: false,
            wageIncreaseText: '',
          },
          monthExpend: {
            monthExpendStatus: false,
            monthExpendText: '',
          },
          pensionPaymentScale: {// 养老缴费档次
            pensionPaymentScaleStatus: false,
            pensionPaymentScaleText: '',
          },
          // 每月领取社保养老金
          socialSecurityPension: {
            socialSecurityPensionStatus: false,
            socialSecurityPensionText: '',
          },
        },
      },
    };
  },
  watch: {
    obj: {
      immediate: true,
      deep: true,
      handler(v) {
        // 校验数据是否填写完整
        this.handleDataChecked();
        console.log('++++', v);
      },
    },
  },
  created() {
    // 计发月数
    this.monthlyCount();
    // 请求年龄范围
    // this.rangeAge();
    // 请求社保年份范围
    this.rangeYear();
    // 客户基本信息
    this.getCustomerInfo();
  },

  methods: {
    // 将默认值进行处理，针对于后端传递的0
    queryDefault() {
      if (this.obj.oneself.pensionSource === '1') {
        this.obj.oneself.pensionYearEndBalance = this.moneyFilter(this.obj.oneself.pensionYearEndBalance);
        this.obj.oneself.monthSalary = this.moneyFilter(this.obj.oneself.monthSalary);
        this.obj.oneself.wageIncrease = '';
        this.obj.oneself.socialSecurityPension = '';
        this.obj.oneself.socialSecurityYear = this.obj.oneself.socialSecurityYear;
        this.obj.oneself.pensionPaymentScale = '';
      } else if (this.obj.oneself.pensionSource === '3') {
        this.obj.oneself.monthSalary = this.moneyFilter(this.obj.oneself.monthSalary);
        this.obj.oneself.wageIncrease = '';
      } else if (this.obj.oneself.pensionSource === '2') {
        this.obj.oneself.pensionPaymentScale = '';
      }
      if (this.obj.spouseTwo != null) {
        if (this.obj.spouseTwo.pensionSource === '1') {
          this.obj.spouseTwo.pensionYearEndBalance = this.moneyFilter(this.obj.spouseTwo.pensionYearEndBalance);
          this.obj.spouseTwo.monthSalary = this.moneyFilter(this.obj.spouseTwo.monthSalary);
          this.obj.spouseTwo.wageIncrease = '';
          this.obj.spouseTwo.pensionPaymentScale = '';
          this.obj.spouseTwo.socialSecurityPension = '';
          this.obj.spouseTwo.socialSecurityYear = this.obj.spouseTwo.socialSecurityYear;
        } else if (this.obj.spouseTwo.pensionSource === '2') {
          this.obj.spouseTwo.pensionPaymentScale = '';
        } else if (this.obj.spouseTwo.pensionSource === '3') {
          this.obj.spouseTwo.monthSalary = this.moneyFilter(this.obj.spouseTwo.monthSalary);
          this.obj.spouseTwo.wageIncrease = '';
        }
      }
    },
    // 年龄下拉框校验
    selectChecked() {
      // 客户,配偶本人的年龄及退休年龄获取最大值
      // 年龄比较
      const ageCompare = this.obj.oneself.age - this.obj.spouseTwo.age <= 0 ? this.obj.spouseTwo.age : this.obj.oneself.age;
      // 退休年龄比较
      const retirementAgeCompare = this.obj.oneself.retirementAge - this.obj.spouseTwo.retirementAge <= 0 ? this.obj.spouseTwo.retirementAge : this.obj.oneself.retirementAge;
      const results = ageCompare >= this.obj.oneself.endYear || this.obj.oneself.endYear <= retirementAgeCompare;
      if (results) {
        this.pensionInputText.self.retirementAge.statusEndYear = true;
        this.pensionInputText.self.retirementAge.textEndYear = '截止年龄必须大于当前年龄和退休年龄';
      } else {
        this.pensionInputText.self.retirementAge.statusEndYear = false;
        this.pensionInputText.self.retirementAge.textEndYear = '';
      }
    },
    // 输入框校验
    pensionReserveBlurFn(data, e, num) {
      // data是值，num是第几个Input
      // 为空后爆红提示
      // 5表示每月花费 6账户结余 7每月工资
      if (!data) {
        if (num === 1) {
          this.pensionReserveText.currentMoney.currentMoneyStatus = true;
          this.pensionReserveText.currentMoney.currentMoneyText = '请输入已存金额';
        } else if (num === 2) {
          this.pensionReserveText.monthMoney.monthMoneyStatus = true;
          this.pensionReserveText.monthMoney.monthMoneyText = '请输入每月储蓄金额';
        } else if (num === 3) {
          this.pensionReserveText.expectedRevenue.expectedRevenueStatus = true;
          this.pensionReserveText.expectedRevenue.expectedRevenueText = '请输入期望收益';
        } else if (num === 5) {
          this.pensionInputText.self.monthExpend.monthExpendStatus = true;
          this.pensionInputText.self.monthExpend.monthExpendText = '请输入每月开支';
        } else if (num === 6) {
          this.pensionInputText.self.pensionYearEndBalance.pensionYearEndBalanceStatus = true;
          this.pensionInputText.self.pensionYearEndBalance.pensionYearEndBalanceText = '请输入上年末养老金账户结余';
        } else if (num === 7) {
          // 客户每月工资
          this.pensionInputText.self.monthSalary.monthSalaryStatus = true;
          this.pensionInputText.self.monthSalary.monthSalaryText = '请输入每月工资';
        } else if (num === 8) {
          // 客户每年涨幅
          this.pensionInputText.self.wageIncrease.wageIncreaseStatus = true;
          this.pensionInputText.self.wageIncrease.wageIncreaseText = '请输入每年工资涨幅';
        } else if (num === 9) {
          // 缴费养老档次
          this.pensionInputText.self.pensionPaymentScale.pensionPaymentScaleStatus = true;
          this.pensionInputText.self.pensionPaymentScale.pensionPaymentScaleText = '请输入养老金缴费档次';
        } else if (num === 10) {
          // 每月领取养老保险金
          this.pensionInputText.self.socialSecurityPension.socialSecurityPensionStatus = true;
          this.pensionInputText.self.socialSecurityPension.socialSecurityPensionText = '请输入每月社保养老金';
        } else if (num === 11) {
          // 配偶每月开支
          this.pensionInputText.spouse.monthExpend.monthExpendStatus = true;
          this.pensionInputText.spouse.monthExpend.monthExpendText = '请输入每月开支';
        } else if (num === 12) {
          // 配偶养老金账户结余
          this.pensionInputText.spouse.pensionYearEndBalance.pensionYearEndBalanceStatus = true;
          this.pensionInputText.spouse.pensionYearEndBalance.pensionYearEndBalanceText = '请输入上年末养老金账户结余';
        } else if (num === 13) {
          // 配偶每月工资
          this.pensionInputText.spouse.monthSalary.monthSalaryStatus = true;
          this.pensionInputText.spouse.monthSalary.monthSalaryText = '请输入每月工资';
        } else if (num === 14) {
          // 配偶工资涨幅
          this.pensionInputText.spouse.wageIncrease.wageIncreaseStatus = true;
          this.pensionInputText.spouse.wageIncrease.wageIncreaseText = '请输入每年工资涨幅';
        } else if (num === 15) {
          // 配偶养老金缴费档次
          this.pensionInputText.spouse.pensionPaymentScale.pensionPaymentScaleStatus = true;
          this.pensionInputText.spouse.pensionPaymentScale.pensionPaymentScaleText = '请输入养老金缴费档次';
        } else if (num === 16) {
          // 配偶养老金缴费档次
          this.pensionInputText.spouse.socialSecurityPension.socialSecurityPensionStatus = true;
          this.pensionInputText.spouse.socialSecurityPension.socialSecurityPensionText = '请输入每月社保养老金';
        }
      } else if (num === 1) {
        this.pensionReserveText.currentMoney.currentMoneyStatus = false;
        this.pensionReserveText.currentMoney.currentMoneyText = '';
      } else if (num === 2) {
        this.pensionReserveText.monthMoney.monthMoneyStatus = false;
        this.pensionReserveText.monthMoney.monthMoneyText = '';
      } else if (num === 3) {
        this.pensionReserveText.expectedRevenue.expectedRevenueStatus = false;
        this.pensionReserveText.expectedRevenue.expectedRevenueText = '';
      } else if (num === 5) {
        this.pensionInputText.self.monthExpend.monthExpendStatus = false;
        this.pensionInputText.self.monthExpend.monthExpendText = '';
      } else if (num === 6) {
        this.pensionInputText.self.pensionYearEndBalance.pensionYearEndBalanceStatus = false;
        this.pensionInputText.self.pensionYearEndBalance.pensionYearEndBalanceText = '';
      } else if (num === 7) {
        // 客户每月工资
        this.pensionInputText.self.monthSalary.monthSalaryStatus = false;
        this.pensionInputText.self.monthSalary.monthSalaryText = '';
      } else if (num === 8) {
        // 客户每年涨幅
        this.pensionInputText.self.wageIncrease.wageIncreaseStatus = false;
        this.pensionInputText.self.wageIncrease.wageIncreaseText = '';
      } else if (num === 9) {
        // 缴费养老档次
        if (data < 60 || data > 300 || !(parseInt(data) == data)) {
          this.pensionInputText.self.pensionPaymentScale.pensionPaymentScaleStatus = true;
          this.pensionInputText.self.pensionPaymentScale.pensionPaymentScaleText = '养老金缴费档次为60至300间的整数';
          this.obj.oneself.pensionPaymentScale = '';
        } else {
          this.pensionInputText.self.pensionPaymentScale.pensionPaymentScaleStatus = false;
          this.pensionInputText.self.pensionPaymentScale.pensionPaymentScaleText = '';
        }
      } else if (num === 10) {
        // 每月领取养老保险金
        this.pensionInputText.self.socialSecurityPension.socialSecurityPensionStatus = false;
        this.pensionInputText.self.socialSecurityPension.socialSecurityPensionText = '';
      } else if (num === 11) {
        // 配偶每月开支
        this.pensionInputText.spouse.monthExpend.monthExpendStatus = false;
        this.pensionInputText.spouse.monthExpend.monthExpendText = '';
      } else if (num === 12) {
        // 配偶养老金账户结余
        this.pensionInputText.spouse.pensionYearEndBalance.pensionYearEndBalanceStatus = false;
        this.pensionInputText.spouse.pensionYearEndBalance.pensionYearEndBalanceText = '';
      } else if (num === 13) {
        // 配偶每月工资
        this.pensionInputText.spouse.monthSalary.monthSalaryStatus = false;
        this.pensionInputText.spouse.monthSalary.monthSalaryText = '';
      } else if (num === 14) {
        // 配偶工资涨幅
        this.pensionInputText.spouse.wageIncrease.wageIncreaseStatus = false;
        this.pensionInputText.spouse.wageIncrease.wageIncreaseText = '';
      } else if (num === 15) {
        // 配偶养老金缴费档次
        if (data < 60 || data > 300 || !(parseInt(data) == data)) {
          this.pensionInputText.spouse.pensionPaymentScale.pensionPaymentScaleStatus = true;
          this.pensionInputText.spouse.pensionPaymentScale.pensionPaymentScaleText = '养老金缴费档次为60至300间的整数';
          this.obj.spouseTwo.pensionPaymentScale = '';
        } else {
          this.pensionInputText.spouse.pensionPaymentScale.pensionPaymentScaleStatus = false;
          this.pensionInputText.spouse.pensionPaymentScale.pensionPaymentScaleText = '';
        }
      } else if (num === 16) {
        // 每月领取社保养老金
        this.pensionInputText.spouse.socialSecurityPension.socialSecurityPensionStatus = false;
        this.pensionInputText.spouse.socialSecurityPension.socialSecurityPensionText = '';
      }
      // 最后一位是 . 就给他截取掉
      let msg = '';
      if (data.toString().charAt(data.length - 1) === '.') {
        msg = data.substring(0, data.length - 1);
      } else {
        msg = data;
      }
      e.target.value = this.moneyFilter2(e.target.value);
      // 校验数据是否填写完整
      // this.handleDataChecked();
    },
    handleDataChecked() {
      const obj = { self: {}, reserve: {} };
      // 储备金
      obj.reserve = this.obj.threeReserve;
      // 本人数据
      obj.self.retirementAge = this.obj.oneself.retirementAge;
      // 客户,配偶本人的年龄及退休年龄获取最大值
      // 年龄比较
      const ageCompare = this.obj.oneself.age - this.obj.spouseTwo.age <= 0 ? this.obj.spouseTwo.age : this.obj.oneself.age;
      // 退休年龄比较
      const retirementAgeCompare = this.obj.oneself.retirementAge - this.obj.spouseTwo.retirementAge <= 0 ? this.obj.spouseTwo.retirementAge : this.obj.oneself.retirementAge;
      if (this.obj.oneself.endYear > ageCompare && this.obj.oneself.endYear > retirementAgeCompare) {
        obj.self.endYear = this.obj.oneself.endYear;
      } else {
        obj.self.endYear = '';
      }
      obj.self.monthExpend = this.obj.oneself.monthExpend;
      obj.self.pensionSource = this.obj.oneself.pensionSource;
      if ((this.obj.oneself.pensionSource == 2 || this.obj.oneself.pensionSource == 3) && this.obj.oneself.age < this.obj.oneself.retirementAge) {
        // 账户结余
        obj.self.pensionYearEndBalance = this.obj.oneself.pensionYearEndBalance;
        // 社保缴费开始年份
        obj.self.socialSecurityYear = this.obj.oneself.socialSecurityYear;
      }
      if (this.obj.oneself.pensionSource == 2 && this.obj.oneself.age < this.obj.oneself.retirementAge) {
        // 每月工资
        obj.self.monthSalary = this.obj.oneself.monthSalary;
        // 工资涨幅
        obj.self.wageIncrease = this.obj.oneself.wageIncrease;
      } else if (this.obj.oneself.pensionSource == 3 && this.obj.oneself.age < this.obj.oneself.retirementAge) {
        // 养老金缴费档次
        obj.self.pensionPaymentScale = this.obj.oneself.pensionPaymentScale;
      } else if (this.obj.oneself.age >= this.obj.oneself.retirementAge) {
        // 每月领取社保金
        if (this.obj.oneself.pensionSource == 3 || this.obj.oneself.pensionSource == 2) {
          obj.self.socialSecurityPension = this.obj.oneself.socialSecurityPension;
        }
      }
      // 配偶的数据
      if (this.obj.spouseTwo.name != undefined) {
        const spouse = {};
        spouse.retirementAge = this.obj.spouseTwo.retirementAge;
        spouse.monthExpend = this.obj.spouseTwo.monthExpend;
        spouse.pensionSource = this.obj.spouseTwo.pensionSource;
        if ((this.obj.spouseTwo.pensionSource == 2 || this.obj.spouseTwo.pensionSource == 3) && this.obj.spouseTwo.age < this.obj.spouseTwo.retirementAge) {
          spouse.pensionYearEndBalance = this.obj.spouseTwo.pensionYearEndBalance;
          // 社保缴费开始年份
          spouse.socialSecurityYear = this.obj.spouseTwo.socialSecurityYear;
        }
        if (this.obj.spouseTwo.pensionSource == 2 && this.obj.spouseTwo.age < this.obj.spouseTwo.retirementAge) {
          // 每月工资
          spouse.monthSalary = this.obj.spouseTwo.monthSalary;
          // 工资涨幅
          spouse.wageIncrease = this.obj.spouseTwo.wageIncrease;
        } else if (this.obj.spouseTwo.pensionSource == 3 && this.obj.spouseTwo.age < this.obj.spouseTwo.retirementAge) {
          // 养老金缴费档次
          spouse.pensionPaymentScale = this.obj.spouseTwo.pensionPaymentScale;
        } else if (this.obj.spouseTwo.age >= this.obj.spouseTwo.retirementAge) {
          // 每月领取社保金
          if (this.obj.spouseTwo.pensionSource == 3 || this.obj.spouseTwo.pensionSource == 2) {
            spouse.socialSecurityPension = this.obj.spouseTwo.socialSecurityPension;
          }
        }
        obj.spouse = spouse;
      }
      console.log('obj@@@---', obj);
      this.$emit('custObj', obj);
    },
    // 保留两位小数，增加千分符
    moneyFilter2(x) {
      if ((`${x}`).indexOf(',') !== -1) {
        return x;
      }
      // 将入参x转换成float类型的小数。假设入参为100000
      const f = parseFloat(x);
      // 如果为空则返回默认值
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(f)) {
        return '';
      }
      // 将入参四舍五入并保留两位小数
      const f2 = Math.round(x * 100) / 100;
      // 将四舍五入后的入参转为字符类型
      let s = f2.toString();
      // 筛选该入参中是否有小数点 有则返回小数点的位置，没有则返回-1
      let rs = s.indexOf('.');
      // 小于0，代表该入参没有小数点，所以该入参为整数
      if (rs < 0) {
        // 将入参的长度赋值给rs
        rs = s.length;
        // 在入参后连上小数点
        s += '.';
      }
      // 循环在入参后补 100000.00
      while (s.length <= rs + 2) {
        s += '0';
      }
      // 将入参根据小数点分割成两部分。分割后为100000和00。
      const parts = s.toString().split('.');
      // parts[0]为取左边整数位。是正则表达式，如果整数位大于3，就在后边添加逗号(千分符)
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      // 重新拼起来 100,000.00
      return parts.join('.');
    },
    // 保留两位小数，增加千分符
    moneyFilter(x) {
      if ((`${x}`).indexOf(',') !== -1) {
        return x;
      }
      // 将入参x转换成float类型的小数。假设入参为100000
      const f = parseFloat(x);
      // 如果为空则返回默认值
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(f)) {
        return '0.00';
      }
      // 将入参四舍五入并保留两位小数
      const f2 = Math.round(x * 100) / 100;
      // 将四舍五入后的入参转为字符类型
      let s = f2.toString();
      // 筛选该入参中是否有小数点 有则返回小数点的位置，没有则返回-1
      let rs = s.indexOf('.');
      // 小于0，代表该入参没有小数点，所以该入参为整数
      if (rs < 0) {
        // 将入参的长度赋值给rs
        rs = s.length;
        // 在入参后连上小数点
        s += '.';
      }
      // 循环在入参后补 100000.00
      while (s.length <= rs + 2) {
        s += '0';
      }
      // 将入参根据小数点分割成两部分。分割后为100000和00。
      const parts = s.toString().split('.');
      // parts[0]为取左边整数位。是正则表达式，如果整数位大于3，就在后边添加逗号(千分符)
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      // 重新拼起来 100,000.00
      return parts.join('.');
    },
    // 保留4位小数
    moneyFilter3(x) {
      console.log('********x***', x);
      if ((`${x}`).indexOf(',') !== -1) {
        return x;
      }
      // 将入参x转换成float类型的小数。假设入参为100000
      const f = parseFloat(x);
      // 如果为空则返回默认值
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(f)) {
        return '0.00';
      }
      // 将入参四舍五入并保留两位小数
      const f2 = Math.round(x * 100) / 100;
      // 将四舍五入后的入参转为字符类型
      let s = f2.toString();
      // 筛选该入参中是否有小数点 有则返回小数点的位置，没有则返回-1
      let rs = s.indexOf('.');
      // 小于0，代表该入参没有小数点，所以该入参为整数
      if (rs < 0) {
        // 将入参的长度赋值给rs
        rs = s.length;
        // 在入参后连上小数点
        s += '.';
      }
      // 循环在入参后补 100000.00
      while (s.length <= rs + 4) {
        s += '0';
      }
      // 将入参根据小数点分割成两部分。分割后为100000和00。
      const parts = s.toString().split('.');
      // parts[0]为取左边整数位。是正则表达式，如果整数位大于3，就在后边添加逗号(千分符)
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      // 重新拼起来 100,000.00
      return parts.join('.');
    },
    // 校验家庭养老金
    RestrictedMoney(values) {
      return this.plusOrMinus(values.toString());
    },
    RestrictedMoney2(values) {
      return this.plusOrMinus2(values.toString());
    },
    RestrictedMoney3(values) {
      return this.plusOrMinus3(values.toString());
    },
    plusOrMinus(values) {
      let newValue;
      if (!(/[^0-9.]/g.test(values))) {
        // eslint-disable-next-line no-useless-escape
        newValue = values.replace(/[^\-\d.]/g, '').replace(/\-{2,}/g, '-').replace(/^\./g, '')
          .replace(/\.{2,}/g, '.')
          .replace('.', '$#$')
          .replace(/\./g, '')
          .replace('$#$', '.');
        if (newValue.toString().indexOf('.') > 0 && Number(newValue.toString().split('.')[1].length) > 2) {
          // eslint-disable-next-line radix
          newValue = parseInt(parseFloat(newValue) * 100) / 100;
        }
        if ((newValue.toString().split('-').length - 1) > 1) {
          newValue = parseFloat(newValue) || '';
        }
        if ((newValue.toString().split('-').length) > 1 && newValue.toString().split('-')[0].length > 0) {
          newValue = parseFloat(newValue) || '';
        }
        if (newValue.toString().length > 1 && (newValue.toString().charAt(0) === '0'
          || (newValue.toString().length > 2 && newValue.toString().charAt(0) === '-'
            && newValue.toString().charAt(1) === '0' && newValue.toString().charAt(2) !== '.')) && newValue.toString().indexOf('.') < 1) {
          newValue = parseFloat(newValue) || '';
        }
        // 判断整数位最多为7位
        if (newValue.toString().indexOf('.') > 0 && Number(newValue.toString().split('.')[0].length) > 7) {
          newValue = `${newValue.toString().substring(0, 7)}.${newValue.toString().split('.')[1]}`;
        } else if (newValue.toString().indexOf('.') < 0 && Number(newValue.toString().split('.')[0].length) > 7) {
          newValue = newValue.toString().substring(0, 7);
        }
      } else {
        newValue = values.replace(/[^0-9.]/g, '');
      }
      console.log(newValue, '--newValue');
      return newValue;
    },
    plusOrMinus2(values) {
      console.log(values, '--values');
      let newValue;
      if (!(/[^0-9.]/g.test(values))) {
        // eslint-disable-next-line no-useless-escape
        newValue = values.replace(/[^\-\d.]/g, '').replace(/\b(0+){2,}/g, '0').replace(/\-{2,}/g, '-').replace(/^\./g, '')
          .replace(/\.{2,}/g, '.')
          .replace('.', '$#$')
          .replace(/\./g, '')
          .replace('$#$', '.');
        if (newValue.toString().indexOf('.') > 0 && Number(newValue.toString().split('.')[1].length) > 2) {
          // eslint-disable-next-line radix
          newValue = parseInt(parseFloat(newValue) * 100) / 100;
        }
        if ((newValue.toString().split('-').length - 1) > 1) {
          newValue = parseFloat(newValue) || '';
        }
        if ((newValue.toString().split('-').length) > 1 && newValue.toString().split('-')[0].length > 0) {
          newValue = parseFloat(newValue) || '';
        }
        if (newValue.toString().length > 1 && (newValue.toString().charAt(0) === '0'
          || (newValue.toString().length > 2 && newValue.toString().charAt(0) === '-' && newValue.toString().charAt(1) === '0'
            && newValue.toString().charAt(2) !== '.')) && newValue.toString().indexOf('.') < 1) {
          newValue = parseFloat(newValue) || '';
        }
        // 判断整数位最多为3位
        if (newValue.toString().indexOf('.') > 0 && Number(newValue.toString().split('.')[0].length) > 3) {
          newValue = `${newValue.toString().substring(0, 3)}.${newValue.toString().split('.')[1]}`;
        } else if (newValue.toString().indexOf('.') < 0 && Number(newValue.toString().split('.')[0].length) > 3) {
          newValue = newValue.toString().substring(0, 3);
        }
      } else {
        newValue = values.replace(/[^0-9.]/g, '');
      }
      return newValue;
    },
    plusOrMinus3(values) {
      let newValue;
      if (!(/[^0-9.]/g.test(values))) {
        // eslint-disable-next-line no-useless-escape
        newValue = values.replace(/[^\-\d.]/g, '').replace(/\-{2,}/g, '-').replace(/^\./g, '')
          .replace(/\.{2,}/g, '.')
          .replace('.', '$#$')
          .replace(/\./g, '')
          .replace('$#$', '.');
        if (newValue.toString().indexOf('.') > 0 && Number(newValue.toString().split('.')[1].length) > 2) {
          // eslint-disable-next-line radix
          newValue = parseInt(parseFloat(newValue) * 100) / 100;
        }
        if ((newValue.toString().split('-').length - 1) > 1) {
          newValue = parseFloat(newValue) || '';
        }
        if ((newValue.toString().split('-').length) > 1 && newValue.toString().split('-')[0].length > 0) {
          newValue = parseFloat(newValue) || '';
        }
        if (newValue.toString().length > 1 && (newValue.toString().charAt(0) === '0'
          || (newValue.toString().length > 2 && newValue.toString().charAt(0) === '-'
            && newValue.toString().charAt(1) === '0' && newValue.toString().charAt(2) !== '.')) && newValue.toString().indexOf('.') < 1) {
          newValue = parseFloat(newValue) || '';
        }
        // 判断整数位最多为7位
        if (newValue.toString().indexOf('.') > 0 && Number(newValue.toString().split('.')[0].length) > 3) {
          newValue = `${newValue.toString().substring(0, 3)}.${newValue.toString().split('.')[1]}`;
        } else if (newValue.toString().indexOf('.') < 0 && Number(newValue.toString().split('.')[0].length) > 3) {
          newValue = newValue.toString().substring(0, 3);
        }
      } else {
        newValue = values.replace(/[^0-9.]/g, '');
      }
      console.log(newValue, '--newValue');
      return newValue;
    },
    // 获取焦点
    educationReserveFocusFn(e) {
      e.target.value = e.target.value.replace(new RegExp(',', 'g'), '');
    },
    // 获取客户信息
    getCustomerInfo() {
      const parames = {
        data: {
          // 类型：Object  必有字段  备注：业务参数
          cis: JSON.parse(sessionStorage.getItem('curCis')), // 类型：String  必有字段  备注：客户号
          flagFrom: JSON.parse(sessionStorage.getItem('flagFrom')), // 用来判断界面的进入，0从主页进入，1表示点击上一步
          uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
        },
      };
      this.$_post(this.$API.getCustomerInfo, parames).then((res) => {
        this.obj.oneself = res.data.planPensionInfo;
        this.obj.spouseTwo = res.data.wifeInfo;
        // 养老储备金
        this.queryPensionReserve();
        const selfAge = res.data.planPensionInfo.age;
        let mateAge = 0;
        if (this.obj.spouseTwo.name != undefined) {
          mateAge = res.data.wifeInfo.age;
        }
        this.rangeAge(selfAge, mateAge);
        if (res.data.msgTip == '1') {
          this.dialogVisible2 = true;
        }
        console.log('obj---', this.obj);
      });
    },
    // 基础数据处理
    handleData() {
      // 数据初始化时进行位数处理
      if (this.obj.oneself.monthExpend != undefined) {
        this.obj.oneself.monthExpend = this.moneyFilter(this.obj.oneself.monthExpend);
      }
      if (this.obj.spouseTwo.monthExpend != undefined) {
        this.obj.spouseTwo.monthExpend = this.moneyFilter(this.obj.spouseTwo.monthExpend);
      }
      if (this.obj.oneself.pensionYearEndBalance != undefined) {
        this.obj.oneself.pensionYearEndBalance = this.moneyFilter(this.obj.oneself.pensionYearEndBalance);
      }
      if (this.obj.oneself.monthSalary != undefined) {
        this.obj.oneself.monthSalary = this.moneyFilter(this.obj.oneself.monthSalary);
      }
      if (this.obj.oneself.wageIncrease != undefined) {
        this.obj.oneself.wageIncrease = this.moneyFilter(this.obj.oneself.wageIncrease);
      }
      if (this.obj.oneself.pensionPaymentScale != undefined && this.obj.oneself.pensionSource === '3') {
        this.obj.oneself.pensionPaymentScale = this.moneyFilter(this.obj.oneself.pensionPaymentScale);
      } else {
        this.obj.oneself.pensionPaymentScale = '';
      } if (this.obj.oneself.age >= this.obj.oneself.retirementAge) {
        if (this.obj.oneself.pensionSource == 3 || this.obj.oneself.pensionSource == 2) {
          this.obj.oneself.socialSecurityPension = this.moneyFilter(this.obj.oneself.socialSecurityPension);
        } else {
          this.obj.oneself.socialSecurityPension = '';
        }
      } else {
        this.obj.oneself.socialSecurityPension = '';
      }
      if (this.obj.spouseTwo.pensionYearEndBalance != undefined) {
        this.obj.spouseTwo.pensionYearEndBalance = this.moneyFilter(this.obj.spouseTwo.pensionYearEndBalance);
      }
      if (this.obj.spouseTwo.monthSalary != undefined) {
        this.obj.spouseTwo.monthSalary = this.moneyFilter(this.obj.spouseTwo.monthSalary);
      }
      if (this.obj.spouseTwo.wageIncrease != undefined) {
        this.obj.spouseTwo.wageIncrease = this.moneyFilter(this.obj.spouseTwo.wageIncrease);
      }
      if (this.obj.spouseTwo.pensionPaymentScale != undefined && this.obj.spouseTwo.pensionSource === '3') {
        this.obj.spouseTwo.pensionPaymentScale = this.moneyFilter(this.obj.spouseTwo.pensionPaymentScale);
      } else {
        this.obj.spouseTwo.pensionPaymentScale = '';
      } if (this.obj.spouseTwo.age >= this.obj.spouseTwo.retirementAge && this.obj.spouseTwo.socialSecurityPension != undefined) {
        if (this.obj.spouseTwo.pensionSource == 3 || this.obj.spouseTwo.pensionSource == 2) {
          this.obj.spouseTwo.socialSecurityPension = this.moneyFilter(this.obj.spouseTwo.socialSecurityPension);
        } else {
          this.obj.spouseTwo.socialSecurityPension = '';
        }
      } else {
        this.obj.spouseTwo.socialSecurityPension = '';
      }
      // 获取养老金来源的默认值
      this.queryDefault();
      console.log('this.obj.spouseTwo===', this.obj);
    },
    // 查询养老储备金
    queryPensionReserve() {
      const parames = {
        data: {
          // 类型：Object  必有字段  备注：业务参数
          cis: JSON.parse(sessionStorage.getItem('curCis')), // 类型：String  必有字段  备注：客户号
        },
      };
      this.$_post(this.$API.queryPensionReserve, parames).then((res) => {
        this.obj.threeReserve = res.data.pensionPlanReserve;
        // eslint-disable-next-line no-restricted-syntax,guard-for-in
        for (const i in this.obj.threeReserve) {
          if (i === 'currentMoney' || i === 'monthMoney' || i === 'expectedRevenue') {
            // this.educationReserve[i] = Number(this.moneyFilter(this.educationReserve[i]));
            this.obj.threeReserve[i] = this.moneyFilter(this.obj.threeReserve[i]);
          }
        }
        // 数据格式处理
        this.handleData();
      });
    },
    cancel() {
      this.dialogVisible2 = false;
    },
    determine() {
      // 更新客户信息
      const parames = {
        data: {
          cis: JSON.parse(sessionStorage.getItem('curCis')),
          flagFrom: JSON.parse(sessionStorage.getItem('flagFrom')),
          uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
        },
      };
      this.$_post(this.$API.updateCustomer, parames).then((res) => {
        this.obj.oneself = res.data.planPensionInfo;
        this.obj.spouseTwo = res.data.wifeInfo;
        this.handleData();
        this.spouse.byAgeList = [];
        const selfAge = res.data.planPensionInfo.age;
        let mateAge = 0;
        if (this.obj.spouseTwo.name != undefined) {
          mateAge = res.data.wifeInfo.age;
        }
        this.rangeAge(selfAge, mateAge);
        console.log('ones--', this.obj);
        if (res.data.msgTip == '1') {
          this.dialogVisible2 = true;
        } else {
          this.dialogVisible2 = false;
        }
      });
    },
    // 计发月数
    monthlyCount() {
      const parames = {
        data: {
        },
      };
      this.$_post(this.$API.monthlyCount, parames).then((res) => {
        let arr = [];
        arr = res.data.list;
        const arr1 = [];
        const arr2 = [];
        const arr3 = [];
        for (let i = 0; i < arr.length; i++) {
          if (i >= 15) {
            arr2.push(arr[i]);
          } else {
            arr1.push(arr[i]);
          }
          const obj = {};
          obj.value = arr[i].paramExplain;
          obj.label = arr[i].paramExplain;
          arr3.push(obj);
        }
        this.spouse.retireAgeList = arr3;
        this.tableData2 = arr2;
        this.tableData1 = arr1;
      });
    },
    rangeAge(selfAge, mateAge) {
      // 获取最大的年龄值
      const endAge = selfAge - mateAge >= 0 ? selfAge : mateAge;
      let end = 80;
      if (endAge > 70) {
        // 截止年龄的选择
        end = endAge + 10;
        if (end >= 100) {
          end = 100;
        }
      }
      // eslint-disable-next-line no-plusplus
      for (let i = end; i <= 100; i++) {
        const arr = { value: '', label: '' };
        arr.value = i;
        arr.label = i;
        this.spouse.byAgeList.push(arr);
      }
    },
    rangeYear() {
      const myDate = new Date();
      let thisYear = myDate.getFullYear(); // 获取当年年份
      const section = thisYear - 1950;
      const arrYear = [];
      for (var i = 0; i <= section; i++) {
        arrYear.push(thisYear--);
      }
      const arr = [];
      for (var i = 0; i < arrYear.length; i++) {
        const obj = { value: arrYear[i], label: arrYear[i] };
        arr.push(obj);
      }
      this.spouse.BeginningYearList = arr;
      console.log('spouse.BeginningYearList', this.spouse.BeginningYearList);
    },
    // 保留两位小数，增加千分符
    moneyFilter(x) {
      if ((`${x}`).indexOf(',') !== -1) {
        return x;
      }
      // 将入参x转换成float类型的小数。假设入参为100000
      const f = parseFloat(x);
      // 如果为空则返回默认值
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(f)) {
        return '0.00';
      }
      // 将入参四舍五入并保留两位小数
      const f2 = Math.round(x * 100) / 100;
      // 将四舍五入后的入参转为字符类型
      let s = f2.toString();
      // 筛选该入参中是否有小数点 有则返回小数点的位置，没有则返回-1
      let rs = s.indexOf('.');
      // 小于0，代表该入参没有小数点，所以该入参为整数
      if (rs < 0) {
        // 将入参的长度赋值给rs
        rs = s.length;
        // 在入参后连上小数点
        s += '.';
      }
      // 循环在入参后补 100000.00
      while (s.length <= rs + 2) {
        s += '0';
      }
      // 将入参根据小数点分割成两部分。分割后为100000和00。
      const parts = s.toString().split('.');
      // parts[0]为取左边整数位。是正则表达式，如果整数位大于3，就在后边添加逗号(千分符)
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      // 重新拼起来 100,000.00
      return parts.join('.');
    },
    // 去掉千分符
    disMoneyFilter(x) {
      if (x.toString().indexOf(',') === -1) {
        return x;
      }
      return x.toString().replace(new RegExp(',', 'g'), '');
    },
  },
};
</script>
<style lang="scss">
.dataCollection {
  /*input校验*/
  .verificationText{
    color: #F56C6C!important;
    font-size: 12px;
    line-height: 1;
  }
  .verificationText-style-enter-active {
    transition: all .2s ease;
  }
  .verificationText-style-leave-active {
    transition: all .2s ease;
  }
  .verificationText-style-enter, .verificationText-style-leave-to {
    transform: translateY(-15px);
  }
  .Title {
    padding: 20px;
    font-size: 16px;
    border-bottom: 1px solid #eeeeee;
  }
  .information {
    display: flex;
    flex-direction: row;
    .text {
      font-size: 14px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 800;
      color: rgba(48, 49, 51, 1);
    }
  }
  .top {
    background: #fff;
    .single-election {
      display: flex;
      flex-direction: row;
    }
    .oneself {
      > div {
        padding: 10px 0px;
      }
      .single-election {
        div {
          width: 80%;
        }
      }
      width: 50%;
      min-height: 300px;
      padding: 20px;
      border-right: 1px solid #eeeeee;
    }
    .spouse {
      > div {
        padding: 10px 0px;
      }
      .single-election {
        div {
          width: 80%;
        }
      }
      .img {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 210px;
        span {
          padding-left: 20px;
        }
      }
      min-height: 300px;
      width: 50%;
      padding: 20px;
    }
  }
  .dataCollection-bottom {
    margin-top: 15px;
    background: #fff;
    .dataCollection-bottom-left {
      width: 50%;
      padding: 20px;
      > div {
        padding: 10px 0px;
      }
    }
    .dataCollection-bottom-right {
      width: 50%;
      padding: 20px;
      > div {
        .content {
          // display: flex;
          display: -webkit-box;
          flex-direction: row;
          margin: 20px 0px;
        }
        background: #f5f7fa;
        padding: 20px;
        .text {
          margin-bottom: 20px;
        }
        .circular {
          display: inline-block;
          width: 6px;
          height: 6px;
          background: rgba(30, 136, 255, 1);
          border-radius: 50%;
          margin-right: 10px;
          position: relative;
          top: -2px;
        }
      }
    }
  }
  .checkDataCol {
    display: flex;
    flex-direction:column;
  }
  .checkDataRow {
    display: flex;
    flex-direction:row;
    flex-wrap: wrap;
  }
  .location {
    position: relative;
    top: -5px;
  }
  .td-padding{
    padding-left: 20px;
  }
}
</style>
